// extracted by mini-css-extract-plugin
module.exports = {"actions-cnt":"ActionsPopover_actions-cnt__1xAHj","actions-icons-cnt":"ActionsPopover_actions-icons-cnt__1kVH-","actionIcons":"ActionsPopover_actionIcons__31xw7"};